<template src="./index.html"></template>
<style lang="scss" scoped src="./index.scss"></style>
<script>
import {Popup} from 'vant';
export default {
  name:'SelfConfirm',
  components:{Popup},
  props:['Show','text','left_button','right_button'],
  methods:{
    Close(){
      this.$emit('Close');
    },
    Cancel(){
      this.$emit('Cancel');
    },
    Confirm(){
      this.$emit('Confirm');
    },
  },
}
</script>